// extracted by mini-css-extract-plugin
module.exports = {"activeNav":"Settings_activeNav__bBD8B","nav":"Settings_nav__MfEXM"};